var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 236,
    viewBox: "0 0 241 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 4,
    x2: 2,
    y2: 29.0496,
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 2,
    x2: 25.6503,
    y2: 2,
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 25.0496,
    y2: -2,
    transform: "matrix(0 -1 -1 0 0 232)",
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 25.6503,
    y2: -2,
    transform: "matrix(1 0 0 -1 0 232)",
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 25.0496,
    y2: -2,
    transform: "matrix(0 1 1 0 240.799 4)",
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 25.6503,
    y2: -2,
    transform: "matrix(-1 0 0 1 240.799 4)",
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 238.799,
    y1: 232,
    x2: 238.799,
    y2: 206.95,
    stroke: "#6CE3C4",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 240.799,
    y1: 234,
    x2: 215.148,
    y2: 234,
    stroke: "#6CE3C4",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrBorder);
export default __webpack_public_path__ + "static/media/qrBorder.958dc731b6da1e56610aab4e7e3e8977.svg";
export { ForwardRef as ReactComponent };